import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const TagWrapper = styled.div`
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr 1fr;
`;

export const TagButton = styled.button<{ active: boolean; disabled: boolean }>(
    ({ active, disabled, theme: { palette } }) => css`
        background: ${palette.neutral.white};
        border-radius: 5px;
        border: 1px solid ${palette.tertiary.default};
        cursor: pointer;
        display: flex;
        justify-content: center;
        padding: 12px;

        ${active &&
        css`
            background: ${palette.tertiary.default};
            cursor: auto;
        `}

        ${disabled &&
        css`
            border: 1px solid ${palette.tertiary.disabled};
            cursor: auto;
        `}
    `,
);

export const TagButtonText = styled(Typography.TextButton_12)<{
    active: boolean;
    disabled?: boolean;
}>(
    ({ active, disabled, theme: { palette } }) => css`
        color: ${palette.tertiary.default};
        line-height: 16px;
        margin: 0;

        ${active &&
        css`
            color: ${palette.text.white};
        `}

        ${disabled &&
        css`
            color: ${palette.tertiary.disabled};
        `}
    `,
);
